(function(){
  var root = document.querySelector('.hb');
  if(!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('js');
  var winter = root.getAttribute('data-w') === 'true';

  /* titre mot a mot */
  var t = root.querySelector('[data-split]');
  if(t){
    var words = t.textContent.trim().split(/\s+/), html = '';
    for(var i=0;i<words.length;i++){
      html += '<span class="wd"><i style="transition-delay:' + (0.16 + i*0.075) + 's">' + words[i] + '</i></span> ';
    }
    t.innerHTML = html;
  }
  requestAnimationFrame(function(){ root.classList.add('go'); });

  /* revelations */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.1, rootMargin:'0px 0px -5% 0px'});
  root.querySelectorAll('[data-r]').forEach(function(e){ io.observe(e); });

  /* barre de progression */
  var bar = root.querySelector('.hb-prog');
  if(bar){
    addEventListener('scroll', function(){
      var h = document.documentElement.scrollHeight - innerHeight;
      bar.style.width = (h > 0 ? (pageYOffset / h * 100) : 0) + '%';
    }, {passive:true});
  }

  /* tilt des cartes */
  if(!reduce && matchMedia('(hover:hover)').matches){
    root.querySelectorAll('[data-tilt]').forEach(function(c){
      c.addEventListener('pointermove', function(e){
        var r = c.getBoundingClientRect();
        c.style.setProperty('--ry', ((e.clientX - r.left)/r.width - .5) * 9 + 'deg');
        c.style.setProperty('--rx', (-((e.clientY - r.top)/r.height - .5)) * 9 + 'deg');
      });
      c.addEventListener('pointerleave', function(){
        c.style.setProperty('--ry','0deg'); c.style.setProperty('--rx','0deg');
      });
    });
  }

  /* compteurs */
  var cio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, end = parseInt(el.getAttribute('data-count'),10) || 0, t0 = null;
      function step(ts){
        if(!t0) t0 = ts;
        var k = Math.min((ts - t0)/1500, 1), ease = 1 - Math.pow(1-k, 3);
        el.textContent = Math.round(end*ease) + (k === 1 && end >= 100 ? '+' : '');
        if(k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, {threshold:.4});
  root.querySelectorAll('[data-count]').forEach(function(e){ cio.observe(e); });

  /* neige 2D */
  var sn = root.querySelector('.hb-wi__sn');
  if(sn && !reduce){
    var sx = sn.getContext('2d'), fl = [], sw = 0, sh = 0;
    function sres(){
      sw = sn.width = sn.offsetWidth; sh = sn.height = sn.offsetHeight;
      fl = []; var n = Math.round(sw*sh/15000);
      for(var i=0;i<n;i++) fl.push({x:Math.random()*sw, y:Math.random()*sh, r:Math.random()*2.1+.5, v:Math.random()*.6+.22, a:Math.random()*.55+.18, p:Math.random()*6.28});
    }
    sres(); addEventListener('resize', sres);
    var svis = true;
    new IntersectionObserver(function(e){ svis = e[0].isIntersecting; }).observe(sn);
    (function sloop(){
      requestAnimationFrame(sloop);
      if(!svis || !sw) return;
      sx.clearRect(0,0,sw,sh);
      for(var i=0;i<fl.length;i++){
        var f = fl[i];
        f.y += f.v; f.p += .012; f.x += Math.sin(f.p)*.42;
        if(f.y > sh+4){ f.y = -4; f.x = Math.random()*sw; }
        sx.beginPath(); sx.arc(f.x, f.y, f.r, 0, 6.283);
        sx.fillStyle = 'rgba(226,240,250,' + f.a + ')'; sx.fill();
      }
    })();
  }

  /* scene 3D */
  var cv = root.querySelector('.hb-cv');
  if(!cv) return;

  function boot(){
    var R;
    try { R = new THREE.WebGLRenderer({canvas:cv, alpha:true, antialias:true, powerPreference:'high-performance'}); }
    catch(e){ cv.style.display = 'none'; return; }
    R.setPixelRatio(Math.min(devicePixelRatio || 1, 2));
    R.outputEncoding = THREE.sRGBEncoding;

    var sc = new THREE.Scene();
    sc.fog = new THREE.FogExp2(winter ? 0x0b1016 : 0x0a0806, 0.04);
    var cam = new THREE.PerspectiveCamera(34, 1, .1, 120);

    function tex(draw, wd, ht){
      var c = document.createElement('canvas'); c.width = wd; c.height = ht;
      draw(c.getContext('2d'), wd, ht);
      var x = new THREE.CanvasTexture(c); x.encoding = THREE.sRGBEncoding; x.anisotropy = 4; return x;
    }

    var cap = tex(function(g, wd, ht){
      var gr = g.createRadialGradient(wd/2, ht/2, 0, wd/2, ht/2, wd/2);
      gr.addColorStop(0, '#e3b57c'); gr.addColorStop(.75, '#c38a50'); gr.addColorStop(1, '#8e5f33');
      g.fillStyle = gr; g.fillRect(0,0,wd,ht); g.translate(wd/2, ht/2);
      for(var i=1;i<30;i++){
        g.beginPath(); g.arc((Math.random()-.5)*5, (Math.random()-.5)*5, i*wd/62, 0, 6.3);
        g.strokeStyle = 'rgba(92,52,22,' + (.14 + Math.random()*.26) + ')';
        g.lineWidth = 1 + Math.random()*2.2; g.stroke();
      }
      g.strokeStyle = 'rgba(62,34,14,.4)'; g.lineWidth = 2.4;
      for(var k=0;k<8;k++){
        g.beginPath(); g.moveTo(0,0);
        var a = Math.random()*6.28; g.lineTo(Math.cos(a)*wd/2, Math.sin(a)*ht/2); g.stroke();
      }
    }, 512, 512);

    var bark = tex(function(g, wd, ht){
      g.fillStyle = '#432a19'; g.fillRect(0,0,wd,ht);
      for(var i=0;i<1400;i++){
        g.fillStyle = 'rgba(' + (18 + Math.random()*58 | 0) + ',' + (9 + Math.random()*34 | 0) + ',4,' + (Math.random()*.55) + ')';
        g.fillRect(Math.random()*wd, Math.random()*ht, 1 + Math.random()*3.4, 10 + Math.random()*70);
      }
    }, 512, 512);
    bark.wrapS = bark.wrapT = THREE.RepeatWrapping; bark.repeat.set(3,1);

    var mSide = new THREE.MeshStandardMaterial({map:bark, roughness:.92, metalness:0});
    var mCap  = new THREE.MeshStandardMaterial({map:cap,  roughness:.82, metalness:0});

    var grp = new THREE.Group(); sc.add(grp);

    var gTex = tex(function(g, wd, ht){
      var gr = g.createRadialGradient(wd/2, ht/2, 0, wd/2, ht/2, wd/2);
      gr.addColorStop(0, 'rgba(255,135,45,.6)');
      gr.addColorStop(.3, 'rgba(190,80,25,.2)');
      gr.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = gr; g.fillRect(0,0,wd,ht);
    }, 512, 512);
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(34,34), new THREE.MeshBasicMaterial({map:gTex, transparent:true, blending:THREE.AdditiveBlending, depthWrite:false}));
    floor.rotation.x = -Math.PI/2; floor.position.y = -.55; grp.add(floor);

    var rows = [4,3,3,2,1];
    for(var r=0;r<rows.length;r++){
      for(var i=0;i<rows[r];i++){
        var rad = .47 + (Math.random()-.5)*.07, len = 3 + Math.random()*.7;
        var m = new THREE.Mesh(new THREE.CylinderGeometry(rad, rad*.97, len, 30), [mSide, mCap, mCap]);
        m.rotation.z = Math.PI/2; m.rotation.y = (Math.random()-.5)*.1;
        m.position.set((Math.random()-.5)*.34, -.1 + r*.86, (i - (rows[r]-1)/2)*1.0 + (Math.random()-.5)*.08);
        grp.add(m);
      }
    }

    var fTex = tex(function(g, wd, ht){
      var gr = g.createRadialGradient(wd/2, ht*.62, 0, wd/2, ht*.62, wd/2);
      gr.addColorStop(0, 'rgba(255,240,190,.95)');
      gr.addColorStop(.18, 'rgba(255,170,60,.8)');
      gr.addColorStop(.46, 'rgba(255,96,20,.33)');
      gr.addColorStop(1, 'rgba(255,60,0,0)');
      g.fillStyle = gr; g.fillRect(0,0,wd,ht);
    }, 256, 256);

    var flames = [];
    for(var f=0;f<5;f++){
      var sp = new THREE.Sprite(new THREE.SpriteMaterial({map:fTex, blending:THREE.AdditiveBlending, depthWrite:false, transparent:true, opacity:.5}));
      var s = 3.4 + f*1.5;
      sp.scale.set(s, s*.82, 1);
      sp.position.set((Math.random()-.5)*.8, 1.3 + f*.3, -.6 - f*.25);
      grp.add(sp);
      flames.push({s:sp, b:s, o:Math.random()*6.28, k:.9 + f*.28});
    }

    var ringG = new THREE.BufferGeometry(), rp = new Float32Array(260*3);
    for(var i=0;i<260;i++){
      var a2 = Math.random()*6.283, rr = 5.4 + Math.random()*1.3;
      rp[i*3] = Math.cos(a2)*rr; rp[i*3+1] = (Math.random()-.5)*4.4; rp[i*3+2] = Math.sin(a2)*rr;
    }
    ringG.setAttribute('position', new THREE.BufferAttribute(rp,3));
    var ring = new THREE.Points(ringG, new THREE.PointsMaterial({color:0xc9955c, size:.045, transparent:true, opacity:.5, blending:THREE.AdditiveBlending, depthWrite:false}));
    grp.add(ring);

    sc.add(new THREE.HemisphereLight(winter ? 0x8fb6d6 : 0xffd3a4, 0x140c06, .5));
    var fire = new THREE.PointLight(0xff7a2e, 2.6, 20, 2);
    fire.position.set(0, .5, 1.6); grp.add(fire);
    var rim = new THREE.DirectionalLight(winter ? 0xbfe0ff : 0xffb070, 1.05);
    rim.position.set(-6, 7, -5); sc.add(rim);
    var key = new THREE.DirectionalLight(0xffe0bb, .4);
    key.position.set(5, 4, 6); sc.add(key);

    function pts(n, col, size, op, fn){
      var g2 = new THREE.BufferGeometry(), p = new Float32Array(n*3);
      for(var i=0;i<n;i++) fn(p, i);
      g2.setAttribute('position', new THREE.BufferAttribute(p,3));
      var pm = new THREE.Points(g2, new THREE.PointsMaterial({color:col, size:size, transparent:true, opacity:op, blending:THREE.AdditiveBlending, depthWrite:false, sizeAttenuation:true}));
      sc.add(pm); return pm;
    }
    var emb = pts(230, 0xff8a3a, .07, .95, function(p,i){
      p[i*3] = (Math.random()-.5)*9; p[i*3+1] = Math.random()*9 - 1; p[i*3+2] = (Math.random()-.5)*5;
    });
    var embV = [];
    for(var i=0;i<230;i++) embV.push(.009 + Math.random()*.02);
    var snow = winter ? pts(520, 0xffffff, .055, .8, function(p,i){
      p[i*3] = (Math.random()-.5)*22; p[i*3+1] = Math.random()*14 - 2; p[i*3+2] = (Math.random()-.5)*13;
    }) : null;

    var mx = 0, my = 0, cmx = 0, cmy = 0, sy = 0;
    addEventListener('pointermove', function(e){ mx = e.clientX/innerWidth - .5; my = e.clientY/innerHeight - .5; }, {passive:true});
    addEventListener('scroll', function(){ sy = pageYOffset || 0; }, {passive:true});

    function size(){
      var wd = cv.clientWidth, ht = cv.clientHeight;
      if(!wd || !ht) return;
      R.setSize(wd, ht, false);
      cam.aspect = wd/ht; cam.updateProjectionMatrix();
      var big = wd > 900;
      grp.position.x = big ? 2.9 : 0;
      grp.position.y = big ? -.7 : -1.9;
      grp.scale.setScalar(big ? 1 : .62);
      emb.position.x = grp.position.x; emb.position.y = grp.position.y;
    }
    size(); addEventListener('resize', size);

    var clock = new THREE.Clock(), vis = true, zoom = 3.4;
    new IntersectionObserver(function(e){ vis = e[0].isIntersecting; }).observe(cv);

    function frame(){
      requestAnimationFrame(frame);
      if(!vis) return;
      var tt = clock.getElapsedTime();
      zoom += (0 - zoom) * 0.016;
      cmx += (mx - cmx) * .045; cmy += (my - cmy) * .045;
      cam.position.set(cmx*1.5, 2.6 + zoom*.5 - cmy*1.1 + sy*0.0016, 15 + zoom);
      cam.lookAt(grp.position.x*0.55, 1.1 + grp.position.y*.5, 0);

      grp.rotation.y = -.5 + Math.sin(tt*.17)*.1;
      ring.rotation.y = tt*.08;
      ring.rotation.x = Math.sin(tt*.13)*.06;

      fire.intensity = 2.3 + Math.sin(tt*9.3)*.42 + Math.sin(tt*21.7)*.24 + Math.sin(tt*3.1)*.2;
      for(var i=0;i<flames.length;i++){
        var o = flames[i];
        var k = 1 + Math.sin(tt*o.k*2.3 + o.o)*.13 + Math.sin(tt*o.k*5.7 + o.o)*.06;
        o.s.scale.set(o.b*k, o.b*.82*k*1.1, 1);
        o.s.material.opacity = .3 + Math.abs(Math.sin(tt*o.k*1.7 + o.o))*.4;
        o.s.position.x = Math.sin(tt*o.k*.9 + o.o)*.3;
      }
      floor.material.opacity = .8 + Math.sin(tt*7)*.1;

      var a3 = emb.geometry.attributes.position;
      for(var i=0;i<a3.count;i++){
        var y = a3.getY(i) + embV[i];
        if(y > 9){ y = -1; a3.setX(i, (Math.random()-.5)*9); }
        a3.setY(i, y);
        a3.setX(i, a3.getX(i) + Math.sin(tt*1.6 + i)*.0035);
      }
      a3.needsUpdate = true;

      if(snow){
        var s2 = snow.geometry.attributes.position;
        for(var j=0;j<s2.count;j++){
          var yy = s2.getY(j) - .019;
          if(yy < -2) yy = 13;
          s2.setY(j, yy);
          s2.setX(j, s2.getX(j) + Math.sin(tt*.5 + j)*.0032);
        }
        s2.needsUpdate = true;
      }

      R.render(sc, cam);
    }

    if(reduce){
      cam.position.set(0, 2.6, 15);
      cam.lookAt(grp.position.x*0.55, 1.1 + grp.position.y*.5, 0);
      R.render(sc, cam);
    } else {
      frame();
    }
  }

  if(window.THREE){ boot(); }
  else {
    var s3 = document.createElement('script');
    s3.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    s3.onload = boot;
    s3.onerror = function(){ cv.style.display = 'none'; };
    document.head.appendChild(s3);
  }
})();